import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";

export class GetServicesTypeDetailCommand extends IRequestCommand<
  IGetServicesTypeDetailResponse,
  ErrorDetails,
  IGetServicesTypeDetailCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/{serviceTypeId}';
  public override setParameters(parameters: IGetServicesTypeDetailCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
        '{serviceTypeId}',
        parameters.serviceTypeId.toString()
    );
  }
}

export interface IGetServicesTypeDetailCommandParameters extends ICommandParameters {
  carrierId: string;
  serviceTypeId: number;
}

export interface IGetServicesTypeDetailResponse
  extends ServiceTypeResponseDTO,
    ICommandResponse {}


export interface VehicleTypeDTO {
    id: number;
    transportypeId: number;
    name: string;
}

export interface OtherCostDTO {
    id: number;
    carrierOtherCostId: number;
    name: string;
}

export interface ServiceTypeResponseDTO {
    id: number;
    active: boolean;
    type: string;
    name: string;
    description: string;
    hourly: boolean;
    oneWay: boolean;
    roundTrip: boolean;
    courier: boolean;
    defaultPickupType: string;
    defaultDropoffType: string;
    vehicleTypeProgrammedAll: boolean;
    vehicleTypeOnDemandAll: boolean;
    extraOptionsAll: boolean;
    vehicleTypesOnDemand: VehicleTypeDTO[] | null;       // Array de objetos VehicleTypeDTO
    vehicleTypesProgrammed: VehicleTypeDTO[] | null;     // Array de objetos VehicleTypeDTO
    otherCosts: OtherCostDTO[] | null;                   // Array de objetos OtherCostDTO

    contractorAccountId: number;
    carrierRateId: number;
    defaultPaymentMethod: string;
    paymentTerm: number;
    pickupAreaId: number;
    dropoffAreaId: number;
    contractorAccountName: string;
    carrierRateName: string;

    //valores ticket 4760
    allowStops: boolean;
    authRequired: boolean;
    hasUseLimit: boolean;
    hasAvailabilityTime: boolean;
    useLimit: number;
    periodType: string;
    dateFrom: string;            // ISO 8601 date
    dateTo: string;              // ISO 8601 date
    paxQtyRequired: number;
    schedule: ScheduleDto[];
    employees: number[];

    //TICKET 4826
    showPax?: boolean;
    shortName?: string;
    iconUrl?: string ;
    predefPickup?: string;
    setPickup?: string | any;
    predefDropoff?: string;
    setDropoff?: string | any;
}

export interface ScheduleDto {
  day: string;
  hourFrom: string;
  hourTo: string;
}
